import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const OutputFormatScreen = lazy(() => import('~/features/item-setup/pages/output-format-screen'));

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/output-format')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <OutputFormatScreen />
    </Suspense>
  ),
});
